<template>
  <div @click="handleClick()">
    <slot v-bind:selected="selected">Base tab header</slot>
  </div>
</template>

<script>
export default {
  props: {
    tabIndex: {
      required: true,
      type: Number
    },
    disabled: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    selected() {
      const { value } = this.getTabState();
      return this.tabIndex === value;
    }
  },
  methods: {
    handleClick() {
      const { update } = this.getTabState();
      if (!this.disabled) {
        update(this.tabIndex);
      }
    }
  },
  inject: ["getTabState"]
};
</script>

<style lang="scss" scoped></style>
